/* ══════════════════════════════════════════════════════════════════
   LUZ REGIA · motor de movimiento — sin librerías.
   Mismo enfoque que caffi.com.ar: IntersectionObserver + clases CSS.
   ══════════════════════════════════════════════════════════════════ */
(() => {
  'use strict';
  /* OJO: Shopify NO interpreta Liquid dentro de assets/*.js, así que aquí no se
     puede usar {{ section.id }}. El contenedor se marca con data-lrh-root y el
     motor corre una vez por instancia. */
  const ROOTS = [...document.querySelectorAll('[data-lrh-root]')];
  if (!ROOTS.length) return;
  ROOTS.forEach((ROOT) => {
  const q  = (s, r = ROOT) => [...r.querySelectorAll(s)];
  const quiet = matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ── 1 · entradas por scroll ───────────────────────────────────── */
  const io = new IntersectionObserver((es) => {
    es.forEach((e) => {
      if (!e.isIntersecting) return;
      e.target.style.setProperty('--d', e.target.dataset.lrD || 0);
      e.target.classList.add('is-in');
      io.unobserve(e.target);
    });
  }, { rootMargin: '0px 0px -12% 0px', threshold: 0.08 });
  /* El hero entra AL CARGAR, no al scrollear. En el prototipo caía dentro de la
     línea del observer por casualidad; con el header del tema (+ badge Trustpilot)
     los botones quedan 4 px por debajo y no aparecían nunca hasta hacer scroll. */
  const hero = ROOT.querySelector('.hero');
  q('[data-lr-in]').forEach((el) => {
    if (hero && hero.contains(el)) {
      el.style.setProperty('--d', el.dataset.lrD || 0);
      el.classList.add('is-in');
      return;
    }
    io.observe(el);
  });

  /* ── 2 · obturador del hero ────────────────────────────────────── */
  const shutter = ROOT.querySelector('[data-lr-shutter]');
  if (shutter) {
    const go = () => requestAnimationFrame(() => shutter.classList.add('is-go'));
    const img = shutter.querySelector('.shot__img');
    // esperamos al frasco: si arranca antes, las hojas abren sobre un hueco
    if (img && !img.complete) { img.addEventListener('load', go, { once: true }); setTimeout(go, 1800); }
    else go();
  }

  /* ── 3 · marquee: duplicamos el set para que el bucle no salte ─── */
  q('[data-lr-marquee]').forEach((m) => {
    const track = m.querySelector('.mq__track');
    track.append(track.firstElementChild.cloneNode(true));
  });
  q('[data-lr-rail]').forEach((r) => {
    const track = r.querySelector('.tst__track');
    [...track.children].forEach((c) => track.append(c.cloneNode(true)));
  });

  /* ── 4 · contadores ────────────────────────────────────────────── */
  const fmt = (n, sep) => (sep ? n.toLocaleString('es-MX') : String(n));
  const easeOut = (t) => 1 - Math.pow(1 - t, 3);
  const countUp = (el) => {
    const end = +el.dataset.lrCount;
    const sep = el.hasAttribute('data-lr-sep');
    if (quiet) { el.textContent = fmt(end, sep); return; }
    const dur = 1500, t0 = performance.now();
    const tick = (t) => {
      const p = Math.min((t - t0) / dur, 1);
      el.textContent = fmt(Math.round(end * easeOut(p)), sep);
      if (p < 1) requestAnimationFrame(tick);
    };
    requestAnimationFrame(tick);
  };
  const ioC = new IntersectionObserver((es) => {
    es.forEach((e) => { if (e.isIntersecting) { countUp(e.target); ioC.unobserve(e.target); } });
  }, { threshold: 0.6 });
  q('[data-lr-count]').forEach((el) => ioC.observe(el));

  /* ── 5 · filas de la comparativa, escalonadas ──────────────────── */
  const ioR = new IntersectionObserver((es) => {
    es.forEach((e) => {
      if (!e.isIntersecting) return;
      const rows = q('[data-lr-cmp-row]', e.target);
      rows.forEach((r, i) => setTimeout(() => r.classList.add('is-on'), quiet ? 0 : i * 90));
      ioR.unobserve(e.target);
    });
  }, { threshold: 0.2 });
  q('[data-lr-cmp]').forEach((el) => ioR.observe(el));

  /* ── 6 · «cómo funciona»: paso activo + barra de avance ────────── */
  const how = ROOT.querySelector('[data-lr-how]');
  if (how) {
    const steps = q('[data-lr-how-step]', how);
    const bar   = how.querySelector('[data-lr-how-bar]');
    const pct   = how.querySelector('[data-lr-how-pct]');
    const ioS = new IntersectionObserver((es) => {
      es.forEach((e) => {
        if (!e.isIntersecting) return;
        const i = steps.indexOf(e.target);
        steps.forEach((s, j) => s.classList.toggle('is-on', j <= i));
        if (bar) bar.style.width = `${((i + 1) / steps.length) * 100}%`;
        if (pct) pct.textContent = String(i + 1).padStart(2, '0');
      });
    }, { rootMargin: '-45% 0px -45% 0px' });
    steps.forEach((s) => ioS.observe(s));
    steps[0]?.classList.add('is-on');
    if (bar) bar.style.width = `${(1 / steps.length) * 100}%`;
  }

  /* ── 7 · header pegado + botón de volver arriba ────────────────── */
  const up = ROOT.querySelector('[data-lr-totop]');
  let tick = false;
  const onScroll = () => {
    const y = scrollY;
    up?.classList.toggle('is-on', y > innerHeight * 1.2);
    tick = false;
  };
  addEventListener('scroll', () => { if (!tick) { tick = true; requestAnimationFrame(onScroll); } }, { passive: true });
  onScroll();
  up?.addEventListener('click', () => scrollTo({ top: 0, behavior: quiet ? 'auto' : 'smooth' }));
  });
})();
